import { ArrowRight, Info } from 'lucide-react'

import { ButtonLink } from '@/components/ButtonLink'
import { InnerHero } from '@/components/InnerHero'
import { Reveal } from '@/components/Reveal'
import { routeSteps } from '@/data/site'

export function CriticalRoutePage() {
  return (
    <>
      <InnerHero
        eyebrow="Un mapa para el inicio"
        title="Ruta crítica"
        description="Cuando todo parece urgente, ordenar los próximos pasos puede devolver un poco de claridad. Esta guía es un punto de partida para conversar con profesionales."
      />

      <section className="section-space pt-0" aria-labelledby="route-title">
        <div className="container-copy">
          <Reveal>
            <div className="mb-8 flex items-start gap-4 rounded-[1.5rem] bg-lime/60 p-5">
              <Info aria-hidden="true" className="mt-1 shrink-0 text-ink" />
              <p className="m-0 text-sm leading-relaxed text-ink-deep/75">
                Esta ruta ofrece orientación general. No sustituye atención de
                emergencia, diagnóstico ni indicaciones del equipo médico que conoce
                el caso.
              </p>
            </div>
            <p className="eyebrow">Seis momentos</p>
            <h2 className="section-title" id="route-title">
              Del desorden inicial a un plan compartido.
            </h2>
          </Reveal>

          <ol className="route-list">
            {routeSteps.map((step, index) => (
              <Reveal delay={index * 0.05} key={step.title}>
                <li className="route-step">
                  <span className="route-number">{index + 1}</span>
                  <div>
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                  <ArrowRight aria-hidden="true" className="text-orange" />
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <section className="section-space bg-ink-deep text-white">
        <div className="container-copy text-center">
          <Reveal>
            <p className="eyebrow justify-center !text-apricot before:!bg-apricot">
              No tienes que resolver todo hoy
            </p>
            <h2 className="section-title mx-auto">Empieza con una pregunta y una persona de confianza.</h2>
            <p className="lede mx-auto mt-6 !text-white/65">
              Si conoces un recurso que podría mejorar esta ruta, queremos escucharte.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
              <ButtonLink href="/contacto/" variant="primary">
                Hablar con la comunidad
              </ButtonLink>
              <ButtonLink href="/recursos/" variant="light">
                Explorar recursos
              </ButtonLink>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  )
}
